module.exports = __webpack_public_path__ + "static/media/playing.ff9a0022.png";